module.exports = __webpack_public_path__ + "static/assets/a8c1fa685a05ebc7d9ced4a1fabce2ec.png";